import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var checkUserDetailsValidity = function (i18n, user) {
    var _a = user || {}, username = _a.username, email = _a.email, firstName = _a.firstName, lastName = _a.lastName, groups = _a.groups;
    var EMAIL_REGEX = /^[\w.\-%+]+@([\w-]+\.)+[[\w]{2,}$/g;
    var isFirstNameError = !firstName || firstName.length < 1;
    var isEmailError = !email || email.length < 1 || !email.match(EMAIL_REGEX);
    var isGroupsError = !groups || groups.length < 1;
    var isLastNameError = !lastName || lastName.length < 1;
    var isUsernameError = !username || username.length < 4;
    return {
        firstName: {
            isError: isFirstNameError,
            infoMessage: getPropsByKeyPath(i18n, 'components.addOrEditUserModal.emptyNotAuthorize'),
        },
        email: {
            isError: isEmailError,
            infoMessage: getPropsByKeyPath(i18n, 'components.addOrEditUserModal.errorEmailLabel'),
        },
        groups: {
            isError: isGroupsError,
            infoMessage: getPropsByKeyPath(i18n, 'components.addOrEditUserModal.emptyNotAuthorize'),
        },
        lastName: {
            isError: isLastNameError,
            infoMessage: getPropsByKeyPath(i18n, 'components.addOrEditUserModal.emptyNotAuthorize'),
        },
        username: {
            isError: isUsernameError,
            infoMessage: getPropsByKeyPath(i18n, 'components.addOrEditUserModal.errorUsernameLabel'),
        },
    };
};
